module.exports = __webpack_public_path__ + "static/media/qash.1baba72a.svg";